import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ResolutionNavHelper {
  isMenuCollapsed = true;
  isTitleCollapsed = true;

  hideSideNav() {
    this.isMenuCollapsed = true;
    this.updateTitleVisibility();
  }

  toggleSideNav() {
    this.isMenuCollapsed = !this.isMenuCollapsed;
    // Update title visibility but don't auto-adjust collapse state (user action)
    this.updateTitleVisibility(false);
  }

  updateTitleVisibility(autoAdjustCollapse = true) {
    const toggleButton = document.getElementById('toggleButton');
    const toggleButtonIsVisible = toggleButton && toggleButton.offsetParent !== null;
    this.isTitleCollapsed = !toggleButtonIsVisible || !this.isMenuCollapsed;

    // Only auto-adjust collapse state on initialization/resize, not on manual toggle
    if (autoAdjustCollapse) {
      if (!toggleButtonIsVisible && this.isMenuCollapsed) {
        this.isMenuCollapsed = false; // Auto-expand on desktop
      } else if (toggleButtonIsVisible && !this.isMenuCollapsed) {
        this.isMenuCollapsed = true; // Auto-collapse on mobile
      }
    }
  }
}
